import { Link } from 'react-router-dom';

const HitotsuzuriContact = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="bg-[#F8FBF6] rounded-2xl p-8 md:p-12">
          <div className="text-center mb-8">
            <h4 className="text-xl md:text-2xl font-bold text-[#89B56B] mb-4 font-['Noto_Sans_JP']">
              法人向けカスタマイズ・開発のご相談
            </h4>
            <p className="text-[13px] text-gray-600 leading-relaxed max-w-2xl mx-auto">
              社内運用に合わせた機能追加、画面・ブランドの調整、導入支援などは、別途ご相談ください。<br />
              PDFツール以外の業務アプリ・社内ツールの開発も承ります。
            </p>
            <ul className="mt-6 inline-block text-left">
              <li className="flex items-start gap-2 text-[13px] text-gray-600 leading-relaxed mb-2">
                <span className="text-[#89B56B] mt-1">●</span>
                <span>社内フォルダ構成や命名ルールに合わせた保存処理</span>
              </li>
              <li className="flex items-start gap-2 text-[13px] text-gray-600 leading-relaxed mb-2">
                <span className="text-[#89B56B] mt-1">●</span>
                <span>既存業務システムとの連携</span>
              </li>
              <li className="flex items-start gap-2 text-[13px] text-gray-600 leading-relaxed">
                <span className="text-[#89B56B] mt-1">●</span>
                <span>社内向け専用ビルド・配布方法の整備</span>
              </li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center px-8 py-3.5 bg-[#89B56B] text-white text-sm font-bold rounded-lg hover:bg-[#5DAA68] transition-colors cursor-pointer whitespace-nowrap shadow-[0_4px_16px_rgba(137,181,107,0.3)]"
            >
              お問い合わせ
            </Link>
            <Link
              to="/products"
              className="inline-flex items-center justify-center px-8 py-3.5 bg-white text-[#5DAA68] border border-[#5DAA68] text-sm font-bold rounded-lg hover:bg-[#89B56B] hover:text-white hover:border-[#89B56B] transition-colors cursor-pointer whitespace-nowrap"
            >
              プロダクト一覧へ
            </Link>
          </div>

          <div className="mt-8 pt-6 border-t border-[#89B56B]/20 text-center">
            <p className="text-[12px] text-gray-500">
              お問い合わせの件名例：「一綴りについて」「ツール開発のご相談」
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HitotsuzuriContact;